import NavFooter from '../nav-main/src/v2/nav-footer';

/* istanbul ignore next */
NavFooter.install = function(Vue) {
  Vue.component(NavFooter.name, NavFooter);
};

export default NavFooter;
